import { memo } from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingStateProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
}

const LoadingState = memo(({ message = "Loading...", size = 'md' }: LoadingStateProps) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  };

  const containerClasses = {
    sm: 'py-6',
    md: 'py-12',
    lg: 'py-16'
  };

  return (
    <div className={`flex items-center justify-center ${containerClasses[size]}`}>
      <div className="flex items-center space-x-3 text-gray-500">
        <Loader2 className={`${sizeClasses[size]} animate-spin`} />
        <span className="text-sm font-medium">{message}</span>
      </div>
    </div>
  );
});

LoadingState.displayName = 'LoadingState';

export default LoadingState;